// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xgnRc","container__label":"styles_container__label__Zt97h","skeleton-animation":"styles_skeleton-animation__0yzQX"};